import React from 'react'
import { AudioSquare } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ClickableAlt from '../ClickableAlt'
import LoadingIndicator from '../LoadingIndicator'

import { UseMediaHandleType } from '../../../../../hooks/useMediaHandle'
import useStyles from './styles'

type AudioProps = {
  mediaHandle: UseMediaHandleType
  onClick: () => void
}

const Audio: React.FC<AudioProps> = ({ mediaHandle, onClick }) => {
  const theme = useTheme()

  const { media, srcURL, downloadAfterLoad, loading, startLoad } = mediaHandle

  const classes = useStyles()

  return (
    <>
      <AudioSquare
        size={theme.size.xxxl}
        variant='Bold'
        color={theme.palette.primary.main}
        className={classes.icon}
      />

      <ClickableAlt onClick={onClick}>{media.filename}</ClickableAlt>

      {srcURL ? (
        <audio
          controls
          loop
          autoPlay={!downloadAfterLoad}
          src={srcURL}
          className={classes.audio}
        />
      ) : (
        <LoadingIndicator loading={loading} onClick={startLoad} />
      )}
    </>
  )
}

export default Audio
